import { render } from "./PostLogin.vue?vue&type=template&id=c948e174"
import script from "./PostLogin.vue?vue&type=script&lang=js"
export * from "./PostLogin.vue?vue&type=script&lang=js"
script.render = render

export default script